type BillingToggleProps = {
  isAnnual: boolean;
  onBillingChange: (isAnnual: boolean) => void;
};

export function BillingToggle({ isAnnual, onBillingChange }: BillingToggleProps) {
  return (
    <div className={`toggle-wrap${isAnnual ? " annual" : " monthly"}`} aria-label="Ciclo de pagamento">
      <div className="billing-toggle" role="group">
        <button
          className={`billing-option${!isAnnual ? " active" : ""}`}
          type="button"
          onClick={() => onBillingChange(false)}
          aria-pressed={!isAnnual}
        >
          Mensal
        </button>
        <button
          className={`billing-option${isAnnual ? " active" : ""}`}
          type="button"
          onClick={() => onBillingChange(true)}
          aria-pressed={isAnnual}
        >
          Anual
        </button>
      </div>
      <span className="toggle-badge">2 meses grátis no anual</span>
    </div>
  );
}
